import(/* webpackMode: "eager" */ "/home/ubuntu/shipsmart/apps/admin/src/app/global-error.tsx");
